module.exports = __webpack_public_path__ + "static/img/5779_phase_function_Paper_PointsHejduk_Prediction.463c751.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5779_phase_function_Paper_PointsHejduk_Prediction.png
// module id = RAQZ
// module chunks = 0